<template>
  <div>
    <div
      class="row"
    >
      <lead-card
        v-for="lead in leads"
        :key="lead.id"
        :lead="lead"
        deletable
        saved
        @delete="onDelete"
      />
    </div>
    <b-modal
      ref="delete-modal"
      title="Mentett kalkuláció törlése"
      show
      @ok="handleDelete"
    >
      Valóban törli ezt a kalkulációt?
    </b-modal>
  </div>
</template>

<script>
  import { Component, Vue } from 'vue-property-decorator';
  import { namespace } from 'vuex-class';

  const savedLeadsModule = namespace('savedLeads');

  @Component
  export default class SavedLeadList extends Vue {
    @savedLeadsModule.Getter('getItems') leads;
    @savedLeadsModule.Getter('isLoading') isLoading;
    @savedLeadsModule.Mutation('setUrl') setUrl;
    @savedLeadsModule.Action('fetchAllWithoutPagination') fetchAll;
    @savedLeadsModule.Action('deleteItem') deleteItem;

    lead = null;

    created() {
      this.setUrl('/hu/profil/mentett-kalkulaciok');
      this.fetchAll();
    }

    onDelete(lead) {
      this.lead = lead;
      this.$refs['delete-modal'].show();
    }

    handleDelete() {
      if (!this.lead) {
        return;
      }

      this.deleteItem(this.lead);
    }
  }
</script>
